export default __webpack_public_path__ + "static/media/hot.7967fa8e.svg";